module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAAAXNSR0IArs4c6QAAAHxJREFUGBltT0kKgDAMjNVH+gA/4smLCooHFaQoePOJQpxIbKXtwEA6S0mImUtwAzMKAbEDBSuYDMyvzTyFZZIGaDXQpwIG5qmBJhXIYV4aqE2UILpVK5yHtHx7aKv9G7KQ3CoYnSEDhO+UBbO/FY8BFFjQG9qqIO5gtNwDdjaRH4NSU+YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 1